/**
 * @generated SignedSource<<9ab14264abdefc0c04b8ac6c828e58e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveWaitingPaymentMethodCreditCard_charge$data = {
  readonly availablePaymentMethods: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly cardProcessingProvider: string | null | undefined;
  readonly company: {
    readonly nameFriendly: string | null | undefined;
    readonly taxID: {
      readonly taxID: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly customer: {
    readonly name: string | null | undefined;
    readonly taxID: {
      readonly taxID: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly identifier: string | null | undefined;
  readonly status: string | null | undefined;
  readonly valueWithDiscount: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveCreditCardValue_charge" | "PaymentLinkAdditionalInfo_charge" | "PaymentLinkComment_charge" | "PaymentMethodCreditCardValue_charge" | "PaymentMethodPaymentDeadline_charge" | "PaymentMethodTransactionDetails_charge">;
  readonly " $fragmentType": "PaymentActiveWaitingPaymentMethodCreditCard_charge";
};
export type PaymentActiveWaitingPaymentMethodCreditCard_charge$key = {
  readonly " $data"?: PaymentActiveWaitingPaymentMethodCreditCard_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveWaitingPaymentMethodCreditCard_charge">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "TaxID",
  "kind": "LinkedField",
  "name": "taxID",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taxID",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActiveWaitingPaymentMethodCreditCard_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "availablePaymentMethods",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameFriendly",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Customer",
      "kind": "LinkedField",
      "name": "customer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "valueWithDiscount",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkComment_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkAdditionalInfo_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentActiveCreditCardValue_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodPaymentDeadline_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodTransactionDetails_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodCreditCardValue_charge"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardProcessingProvider",
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};
})();

(node as any).hash = "c78c2c7d15c7dc0fea01d2d504bd8560";

export default node;
